import React, { Component } from 'react';
import classNames from 'classnames';
import Payment from 'payment';
import './Form.css';
import TrackEvent from '../event';
import Instructions from '../instructions';

import { getStripeToken } from '../stripe/index.js';

class PaymentForm extends Component {
    constructor(props){
        super(props);
        this.hide = this.hide.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.showInstructions = this.showInstructions.bind(this);

        this.state = {
            form: {
                ccNumber: null,
                exp_month: null,
                exp_year: null,
                cvc: null,
                token: null,
            },
            classess: {
                expiration: null,
                ccNumber: null,
                cvc: null
            },
            errors: {
                expiration: false,
                ccNumber: false,
                cvc: false
            },
            subscription: this.props.subscription,
            instructions: false,
            instructionsCode: "",
            loading: false
        }

    }

    componentDidMount(){
        const { ccNumber, expiration, cvc } = this.refs;
        Payment.formatCardNumber(ccNumber);
        Payment.formatCardExpiry(expiration);
        Payment.formatCardCVC(cvc);
    }
    
    hide(){
        // console.log("HIDE IT")
        this.setState({
            open: false
        })
        document.body.style.overflow = ""
        document.body.style.position = ""
        setTimeout(this.props.close,400)
    }

    componentWillMount(){
        this.setState({open:true})
    }

    handleChange(event){

        var isValid,result="";
        
        switch(event.target.name){
            case "ccNumber":
                isValid = Payment.fns.validateCardNumber(event.target.value);
            break;
            case "expiration":
                isValid = Payment.fns.validateCardExpiry(event.target.value);
            break;
            case "cvc":
                isValid = Payment.fns.validateCardCVC(event.target.value);
            break;
            case "email":
                var testEmail =    /^[ ]*([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})[ ]*$/i
                isValid = testEmail.test(event.target.value)
            break;
            default:
                console.log("Hit that def")
            break;
        }

        if(isValid) {
            result = "valid"
            var errors = this.state.errors
            errors[event.target.name] = false;
            this.setState({errors});
        } else if(event.target.value.length > 0){
            result = "filled"
        }

        var classess = this.state.classess
        classess[event.target.name] = result
        this.setState(classess)  
    }

    handleSubmit(event){
        event.preventDefault();

        var _this = this;
        const { refs } = this;

        _this.setState({loading: true});
        
        var invalid = [];
        
        for (var key in refs) {

            var value = refs[key].value,
                isValid = false,
                errors = _this.state.errors;

            if(key === "ccNumber") {
                isValid = Payment.fns.validateCardNumber(value)
            } else if(key === "expiration") {
                isValid = Payment.fns.validateCardExpiry(value)
            } else if(key === "cvc") {
                isValid = Payment.fns.validateCardCVC(value)
            } else if(key === "email" && value.length > 0) {
                var testEmail =    /^[ ]*([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})[ ]*$/i
                isValid = testEmail.test(value);
            }
            
            if(key === "email" && value.length > 0) {}
            
            if(isValid === false) { 
                if(key === "email" && value.length === 0) {
                    
                } else {
                    invalid.push(key)
                    errors[key] = true
                }
            } else {
                errors[key] = false
            }

            _this.setState({errors});
        }
        
        if(invalid.length > 0){
            var classess = _this.state.classess;

            invalid.forEach(function(it){
                classess[it] = "invalid"
            })

            _this.setState({
                classess: classess,
                loading: false
            })
        } else {
            const number = refs.ccNumber.value;
            const expiration = refs.expiration.value.split('/');
            const exp_month = parseInt(expiration[0], 10);
            const exp_year = parseInt(expiration[1], 10);
            const cvc = refs.cvc.value;
            const card = { number, exp_month, exp_year, cvc };
            
            getStripeToken(card)
            .then((token) => {
                card.token = token;
                console.log("Got Stripe token",token)
                console.log("Email is", refs.email.value)

                var cUrl = "https://secure-wifi-api.disconnect.me/v1/completeCharge";
                
                var data = {
                    product_id: this.state.subscription.id,
                    stripeToken: token,
                    source: window.location.href
                }

                if(refs.email.value.length > 0) { data["emailAddress"] = refs.email.value; }
                if(this.state.subscription.expires_in_months != undefined) { data["expires_in_months"] = this.state.subscription.expires_in_months }

                data = formData(data);
                
                function handleErrors(response) {
                    var contentType = response.headers.get("content-type");
                    
                    if (!response.ok || !contentType || !contentType.includes("application/json")) {
                        throw Error(response.statusText);
                    }

                    return response;
                }

                function formData(details){
                    var formBody = [];
                    for (var property in details) {
                        var encodedKey = encodeURIComponent(property);
                        var encodedValue = encodeURIComponent(details[property]);
                        formBody.push(encodedKey + "=" + encodedValue);
                    }
                    formBody = formBody.join("&");
                    return formBody
                }
                
                fetch(cUrl, {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    body: data
                })
                .then(handleErrors)
                .then(this.showInstructions)
                .catch((error) => {
                    console.log("Problem fetching the token", error)

                    var resetFilledForm = {
                        stripeError: true,
                        errors: {
                            expiration: false,
                            ccNumber: false,
                            cvc: false
                        },
                        classess: {
                            expiration: "filled",
                            ccNumber: "filled",
                            cvc: "filled"
                        },
                        loading: false
                    }

                    if(refs.email.value.length > 0) {
                        resetFilledForm.classess["email"] = "filled"
                    }
                    
                    this.setState(resetFilledForm)
                })
                
            }).catch((error) => {
                console.log("Problem fetching the token", error)
                this.setState({
                    stripeError: true,
                    classess: {
                        expiration: "filled",
                        ccNumber: "filled",
                        cvc: "filled"
                    },
                    loading: false
                });
            });
        }
    }

    showInstructions(response){
        
        response.json().then((data) => {

            TrackEvent.event({
                category: "submitPaymentBtn",
                action: "click",
                value: this.state.subscription.price
            })
            
            this.setState({
                instructions: true,
                instructionsCode: data.code,
                loading: false
            })

        })
        
    }

    
    render() {

        var sidebarStyle = classNames("sm-col xs-col-12 sm-col-12 md-col-4 p2", 
            {animateIn: this.state.open ? true : false},
            {animateOut: this.state.open ? false: true}
        );

        var overlayStyle = classNames("overlay",
            {fadeOut:!this.state.open},
            {fadeIn:this.state.open}
        );

        var loadingStyle = classNames("loading", {
            active:this.state.loading
        })
        
        return (
            <div className={overlayStyle}>
                <div className="sm-col sm-hide md-col-8" onClick={this.hide} style={{"height":"100%","content":"","position":"absolute"}}></div>
                <div id="sidebar" className={sidebarStyle}>
                    <div className={loadingStyle}>
                        <span>Loading...</span>
                    </div>
                    { this.state.instructions === true &&
                        <Instructions code={this.state.instructionsCode} hide={this.hide}/>
                    }
                    <icon className="fa fa-close" onClick={this.hide} />                    
                    <h1 className="mb0">Order Summary</h1>
                    <h2 className="mt0">{this.state.subscription.title} : ${this.state.subscription.price}</h2>
                    <hr className="mb2"/>
                    <form onSubmit={this.handleSubmit} className="mt0">
                        <div className="form-input col col-12 my2">
                            <input id="ccNumber" type="tel" name="ccNumber" ref="ccNumber" onChange={this.handleChange} className={this.state.classess.ccNumber}/>  
                            <label htmlFor="ccNumber">
                                <span>Credit Card Number</span>
                            </label>
                            { this.state.errors.ccNumber === true &&
                            <span className="error">Problem with credit card number</span>
                            }
                        </div>
                        <div className="form-input col col-12 my2">
                            <input id="expiration" type="tel" name="expiration" ref="expiration" onChange={this.handleChange} className={this.state.classess.expiration}/>  
                            <label htmlFor="expiration">
                                <span>Expiration</span>
                            </label>
                            { this.state.errors.expiration === true &&
                            <span className="error">Problem with expiration date</span>
                            }
                        </div>
                        <div className="form-input col col-12 my2">
                            <input id="cvc" type="tel" name="cvc" ref="cvc" onChange={this.handleChange} className={this.state.classess.cvc}/>
                            <label htmlFor="cvc">
                                <span>CVC</span>
                            </label>
                            { this.state.errors.cvc === true &&
                            <span className="error">CVC code doesn't match</span>
                            }
                        </div>
                        <div className="form-input col col-12 my2">
                            <input type="email" ref="email" name="email" onChange={this.handleChange} className={this.state.classess.email} />
                            <label htmlFor="email">
                                <span>Email (optional, for receipt)</span>
                            </label>
                            { this.state.errors.email === true &&
                            <span className="error">Please provide a valid email address</span>
                            }
                        </div>
                        { this.state.stripeError === true &&
                        <div className="col col-12 mt2 error center">
                            There was a problem charging your card. Please try again later. 
                        </div>
                        }
                        <div className="col col-12 mt2 center">
                            <button type="submit" className="rounded p2 mb1">Pay & Download</button>
                            <small className="small">Secure payment. Processed by Stripe</small>
                        </div>
                    </form>
                    <div className="clearfix" />
                </div>
            </div>
        )
    }
}

export default PaymentForm;


// WEBPACK FOOTER //
// ./src/paymentForm/index.js